import { cachedFetch, VariantPicker, BuyButtons, Tabs } from "//www.vitrazza.com/cdn/shop/t/285/assets/theme.js?v=144153150827882172641744141996";
// var CustomQuote = class extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.infoPlaceholder = this.querySelector("[data-custom-quote-info]");
//     this._fetchQuote();
//   }

//   disconnectedCallback() {
//     console.info("DISCONNECTED!");
//   }

//   _hideLoader = () => {
//     this.querySelector(".spinner-container").setAttribute("hidden", true);
//   };

//   _showQuote = () => {
//     this.querySelector("[data-custom-quote-content]").removeAttribute("hidden");
//   };

//   _createIntro = text => {
//     /*
//      *  The text we get comes from the customerNotes field of the returned JSON quote object.
//      */
//     const introElement = document.createElement("div");
//     introElement.classList.add("bg-secondary", "text-xs");
//     introElement.innerText = text;
//     this.querySelector("[data-custom-quote-intro]").appendChild(introElement);
//   };

//   _createDownloadButton = () => {
//     /*
//      *  The cute button looking element with the words and download icon
//      */
//     const buttonElement = document.createElement("div");
//     buttonElement.classList.add("custom-quote__download-button");
//     buttonElement.innerHTML = `
//       <span>Download Here</span>
//       <svg style="width: 1.5rem; height: 1.5rem;" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 11.0833H19.355C20.3933 11.0833 20.9067 12.3433 20.1717 13.0783L14.8167 18.4333C14.3617 18.8883 13.6267 18.8883 13.1717 18.4333L7.81666 13.0783C7.08166 12.3433 7.60666 11.0833 8.64499 11.0833H10.5V5.25C10.5 4.60834 11.025 4.08334 11.6667 4.08334H16.3333C16.975 4.08334 17.5 4.60834 17.5 5.25V11.0833ZM7 23.9167C6.35833 23.9167 5.83333 23.3917 5.83333 22.75C5.83333 22.1083 6.35833 21.5833 7 21.5833H21C21.6417 21.5833 22.1667 22.1083 22.1667 22.75C22.1667 23.3917 21.6417 23.9167 21 23.9167H7Z" fill="#ffffff"></path></svg>
//     `;
//     return buttonElement;
//   };

//   _createImageLink = (attachments, originalSrc, custom) => {
//     /*
//      * The attachments we get come from the returned JSON quote object.
//      * Each attachment is an object with a file object
//      * The first attachment file.url is the PDF of the drawing
//      * The second attachment file.url is the JPG of the drawing
//      * We are drawing a link to the PDF with an img tag inside it
//      */
//     const pdfFile = attachments.find(
//       attachment => attachment.file.fileExtension.toUpperCase() === "PDF"
//     );
//     const imgFile = attachments.find(
//       attachment => attachment.file.fileExtension.toUpperCase() !== "PDF"
//     );
//     const pdfLink = document.createElement("a");
//     const linkAttrs = {
//       href: custom ? pdfFile.file.url : "#",
//       target: "_blank",
//       title: "Download PDF",
//       class: "custom-quote__pdf-link",
//     };
//     for (let attr in linkAttrs) {
//       pdfLink.setAttribute(attr, linkAttrs[attr]);
//     }
//     const imgAttrs = {
//       src: custom ? imgFile.file.url : originalSrc,
//       alt: "Custom Quote Drawing",
//       height: 1,
//       width: 1,
//       class: "custom-quote__image",
//     };
//     const imageElement = document.createElement("img");
//     for (let attr in imgAttrs) {
//       imageElement.setAttribute(attr, imgAttrs[attr]);
//     }
//     pdfLink.appendChild(imageElement);
//     this.querySelector("[data-custom-quote-link]").appendChild(pdfLink);
//   };

//   _drawQuoteDetails = lineItems => {
//     lineItems.forEach(item => {
//       const lineItemEl = document.createElement("div");
//       lineItemEl.classList.add("custom-quote__line-item");
//       const lineItemTitle = document.createElement("h3");
//       lineItemTitle.classList.add("custom-quote__line-item-title");
//       lineItemTitle.innerText = item.nameParts.productTitle;
//       lineItemEl.appendChild(lineItemTitle);
//       this.querySelector("[data-custom-quote-info]").appendChild(lineItemEl);
//     });
//   };

//     // shove the quote details into the wrapper
//     quoteDetailsWrapper.replaceChildren(quoteLink, quoteInfo);

//     // show the wrapper
//     this.appendChild(quoteDetailsWrapper);

//     lineItems.forEach((item, index) => {
//       // console.log("quote lineItem 👀 ", item);
//       // create the product title element
//       // this.infoPlaceholder.prependChild(lineItemEl);
//       // const lineItemEl = document.createElement("div");
//       // lineItemEl.classList.add("custom-quote__line-item");
//       // const lineItemTitle = document.createElement("h3");
//       // lineItemTitle.classList.add("custom-quote__line-item-title", "text-lg");
//       // lineItemTitle.innerText = item.nameParts.productTitle;
//       // lineItemEl.appendChild(lineItemTitle);
//       // this.infoPlaceholder.appendChild(lineItemEl);
//     });
//   };

//   _handleAddToCart = evt => {
//     const { target } = evt;
//     const wrapper = target.closest(".custom-quote__info");
//     const selected = wrapper.querySelector("input[type='radio']:checked");
//     console.log("selected: ", selected.value);
//   };

//   _createBuyButtonsForm = (lineItem, formId) => {
//     /* this is the HTML we are trying to use:
//     <form method="post" action="/cart/add" id="product-form-6736175562816-template--14634785013824__main" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
//       <input type="hidden" name="form_type" value="product">
//       <input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="39825384865856">
//       <div class="v-stack gap-4">
//         <buy-buttons class="buy-buttons " template="glass-mats" form="product-form-6736175562816-template--14634785013824__main">
//           <button type="submit" class="button button--xl" is="custom-button">
//             <div style="transform: translateY(0px); opacity: 1;">Add to cart - $195</div>
//             <span class="button__loader" style="transform: translateY(-10px); opacity: 0;">
//             <span style="opacity: 1;"></span>
//             <span style="opacity: 1;"></span>
//             <span style="opacity: 1;"></span>
//             </span>
//           </button>
//         </buy-buttons>
//       </div>
//     </form>
//     */
//     const form = document.createElement("form");
//     const formAttrs = {
//       method: "post",
//       action: "/cart/add",
//       id: formId,
//       acceptCharset: "UTF-8",
//       class: "shopify-product-form",
//       enctype: "multipart/form-data",
//       is: "product-form",
//     };
//     Object.keys(formAttrs).forEach(attr => {
//       form.setAttribute(attr, formAttrs[attr]);
//     });
//     return form;
//   };

//   _createBuyButtons = lineItem => {
//     // significant voodoo here to replicate the buy buttons functionality from the product page
//     /* this is the HTML we are trying to use:
//     <form method="post" action="/cart/add" id="product-form-6736175562816-template--14634785013824__main" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
//       <input type="hidden" name="form_type" value="product">
//       <input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="39825384865856">
//       <div class="v-stack gap-4">
//         <buy-buttons class="buy-buttons " template="glass-mats" form="product-form-6736175562816-template--14634785013824__main">
//           <button type="submit" class="button button--xl" is="custom-button">
//             <div style="transform: translateY(0px); opacity: 1;">Add to cart - $195</div>
//             <span class="button__loader" style="transform: translateY(-10px); opacity: 0;">
//             <span style="opacity: 1;"></span>
//             <span style="opacity: 1;"></span>
//             <span style="opacity: 1;"></span>
//             </span>
//           </button>
//         </buy-buttons>
//       </div>
//     </form>
    
//     const buttonWrapper = document.createElement("div");
//     buttonWrapper.classList.add("custom-quote__add-to-cart-button-wrapper");
//     const addToCartButton = document.createElement("button");
//     addToCartButton.classList.add("custom-quote__add-to-cart-button", "button", "button--lg");
//     addToCartButton.setAttribute("type", "button");
//     addToCartButton.setAttribute("is", "custom-button");
//     addToCartButton.setAttribute("data-add", "Add to cart");
//     addToCartButton.setAttribute("title", "Add to cart");
//     addToCartButton.innerText = "Add to cart";
//     addToCartButton.addEventListener("click", this._handleAddToCart);
//     buttonWrapper.appendChild(addToCartButton);
//     return buttonWrapper;
//     */
//     // console.log("this is the lineItem: ", lineItem);
//     const formId = `product-form-${
//       lineItem.id.split("DraftOrderLineItem/")[1]
//     }`;
//     const form = this._createBuyButtonsForm(lineItem, formId);
//     // add some inputs with some data
//     const input1 = document.createElement("input");
//     input1.setAttribute("type", "hidden");
//     input1.setAttribute("name", "form_type");
//     input1.setAttribute("value", "product");
//     form.appendChild(input1);
//     const input2 = document.createElement("input");
//     input2.setAttribute("type", "hidden");
//     input2.setAttribute("name", "utf8");
//     input2.setAttribute("value", "✓");
//     form.appendChild(input2);
//     const input3 = document.createElement("input");
//     input3.setAttribute("type", "hidden");
//     input3.setAttribute("name", "id");
//     input3.setAttribute("value", lineItem.variant ? lineItem.variant.id : "");
//     form.appendChild(input3);

//     // make an add to cart button
//     const buyButtons = document.createElement("quote-buy-buttons");
//     buyButtons.classList.add("custom-quote__add-to-cart-button-wrapper");
//     buyButtons.setAttribute("template", "glass-mats");
//     buyButtons.setAttribute("form", form.getAttribute("id"));

//     const addToCartButton = document.createElement("button");
//     addToCartButton.classList.add(
//       "custom-quote__add-to-cart-button",
//       "button",
//       "button--lg"
//     );
//     addToCartButton.setAttribute("type", "button");
//     addToCartButton.setAttribute("is", "custom-button");
//     addToCartButton.setAttribute("title", "Add to order");

//     addToCartButton.innerHTML = `
//       <div style="transform: translateY(0px); opacity: 1;">Add to order</div>
//       <span class="button__loader" style="transform: translateY(-10px); opacity: 0;">
//         <span style="opacity: 1;"></span>
//         <span style="opacity: 1;"></span>
//         <span style="opacity: 1;"></span>
//       </span>
//     `;

//     addToCartButton.addEventListener("click", this._handleAddToCart);

//     buyButtons.appendChild(addToCartButton);

//     form.appendChild(buyButtons);

//     return form;
//   };

//   _createQuotes = quotes => {
//     this.quotes = quotes;
//     this._createIntro(quotes[0].customerNotes);
//     this.quotes.forEach((quote, index) => {
//       const { lineItems, attachments } = quote;
//       this._createQuoteDetails(lineItems, index, attachments);
//     });
//     this._showQuote();
//   };

//   _fetchQuote = () => {
//     const quoteId = new URLSearchParams(window.location.search).get("id");
//     const fetchUrl = `https://vitrazza-custom-quote-builder.herokuapp.com/quotes/${quoteId}`;
//     cachedFetch(fetchUrl, {
//       headers: {
//         "Content-Type": "application/json",
//         "Access-Control-Allow-Origin": "*",
//       },
//     })
//       .then(response => {
//         return response.json();
//       })
//       .then(data => {
//         this._createQuotes(data);
//       })
//       .then(this._hideLoader)
//       .catch(err => {
//         this._hideLoader();
//         const errorElement = document.createElement("div");
//         errorElement.classList.add("bg-error", "text-lg");
//         errorElement.innerHTML = `
//           <p>There was an error loading your quote. Please try again later.</p>
//           <p>${err}</p>
//         `;
//         this.innerHTML = errorElement;
//         console.error(err);
//       });
//   };
// };
// if (!window.customElements.get("custom-quote")) {
//   window.customElements.define("custom-quote", CustomQuote);
// }

var VariantPickerVitrazza = class extends VariantPicker{
  constructor(){
    super();
  }
  connectedCallback(){
    super.connectedCallback();
  }
  _onMasterSelectorChanged(){
    super._onMasterSelectorChanged();
    const selectedVariant = this.querySelector("input:checked").value; 
  }
}
if(!window.customElements.get("variant-picker-vitrazza")){
  window.customElements.define("variant-picker-vitrazza", VariantPickerVitrazza);
}

var BuyButtonsVitrazza = class extends BuyButtons {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  _onVariantChanged(evt) {
    super._onVariantChanged(evt);
    if (document.querySelector(".vit-product-picker") && document.querySelector("variant-picker")) {
      const isAvailable = document.querySelector("variant-picker").querySelector("input:checked").dataset.variantAvailable;
      const addToCartButton = this.querySelector('button[type="submit"]');
      const chosenPrice = document.querySelector("variant-picker").querySelector("input:checked").dataset.variantPrice;

      // Format the price with comma separation
      const reversedNumber = chosenPrice.split('').reverse().join('');
      const numberWithCommas = reversedNumber.replace(/\d{3}(?=\d)/g, '$&,');
      const formattedPrice = numberWithCommas.split('').reverse().join('');

      // Clear existing HTML content of the button
      addToCartButton.innerHTML = '';
      
      // Set the "Add to cart" text along with the chosen price
      console.log("isAvailable: ", isAvailable);
      if (isAvailable === "true") {
        addToCartButton.insertAdjacentHTML('beforeend', `Add to cart - <sup>$</sup>${formattedPrice}`);
      } else {
        addToCartButton.insertAdjacentHTML('beforeend', `<div>Sold out</div>`);
      }
    }
  }
};

if (!window.customElements.get("buy-buttons-vitrazza")) {
  window.customElements.define("buy-buttons-vitrazza", BuyButtonsVitrazza);
}

//var BuyButtonsVitrazza = class extends BuyButtons{
//  constructor(){
//    super();
//  }
//  connectedCallback(){
//    super.connectedCallback();
//  }
//  _onVariantChanged(evt){
//    super._onVariantChanged(evt);
//    if(document.querySelector(".vit-product-picker") && document.querySelector("variant-picker")){
//      const addToCartButton = this.querySelector('button[type="submit"]');
//      const chosenPrice = document.querySelector("variant-picker").querySelector("input:checked").dataset.variantPrice;
//      addToCartButton.innerHTML = `Add to cart - <sup>$</sup>${chosenPrice}`;
//    }
//  }
//}
//if(!window.customElements.get("buy-buttons-vitrazza")){
//  window.customElements.define("buy-buttons-vitrazza", BuyButtonsVitrazza);
//}

var TabsVitrazza = class extends Tabs {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback(){
    const variantPicker = document.querySelector("variant-picker");
    this._productForm = document.forms[variantPicker.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    super.connectedCallback();
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener("variant:change", this._onVariantChangedListener);
    super.disconnectedCallback();
  }
  _onVariantChanged(event) {
    document.querySelector(".tabs-inner.active-desktop-variant").classList.remove("active-desktop-variant");
    document.querySelector(`#variant-desktop-${event.detail.variant.id}`).classList.add("active-desktop-variant");
    document.querySelector(".tabs-accordion.active-mobile-variant").classList.remove("active-mobile-variant");
    document.querySelector(`#variant-mobile-${event.detail.variant.id}`).classList.add("active-mobile-variant");
  }
}
if (!window.customElements.get("x-tabs-vitrazza")) {
  window.customElements.define("x-tabs-vitrazza", TabsVitrazza);
}
(function swatchVoodoo() {
  // voodoo to marry the product variations section with the variant-picker section
  // so that when they change glass clarity the prices for the related products update
  const productPicker = document.querySelector(".vit-product-picker");
  const variantPicker = document.querySelector("variant-picker");
  if (!productPicker || !variantPicker || !window.productVariations) {
    return false;
  }

  const showPriceDifference = (pv, priceEl) => {
    // display the price difference between the two glass clarity options
    const claritySwatches = variantPicker.querySelectorAll(".swatch__wrapper.glass-clarity");
    if(claritySwatches.length  !== 2){
      return false;
    }
    const chosenEl = Array.from(claritySwatches).find(sw => sw.querySelector("input").checked);
    const chosenPrice = chosenEl.querySelector("input").dataset.variantPrice;
    const otherEl = Array.from(claritySwatches).find(sw => !sw.querySelector("input").checked);
    const otherPrice = otherEl.querySelector("input").dataset.variantPrice;
    const diff = parseInt(chosenPrice, 10) - parseInt(otherPrice, 10);

    if (diff !== 0){
      chosenEl.querySelector(".variant-label__price-difference").innerHTML = "";
      otherEl.querySelector(".variant-label__price-difference").innerHTML = `${ diff < 0 ? "+" : "-"}$${Math.abs(diff)}`;
    }
  };

  const generatePriceMarkup = pv => {
    if (pv.compare_at_price) {
      return `<s><sup>$</sup>${parseInt(
        pv.compare_at_price / 100
      )}</s> <span class="text-on-sale"><sup>$</sup>${parseInt(
        pv.price / 100
      )}</span>`;
    } else {
      return `<sup>$</sup>${parseInt(pv.price / 100)}`;
    }
  };
  const updateOptions = (evt) => {
    // update add to cart button with price
    const addToCartButtonText = document.querySelector("buy-buttons-vitrazza button[type='submit']");
    // which "color" (glass clarity usually) is selected?
    const colorInput = variantPicker.querySelector("input:checked");
    const chosenColor = colorInput.value;
    const chosenPrice = colorInput.dataset.variantPrice;

    if (!chosenColor || !addToCartButtonText) return false;
    variantPicker.querySelectorAll(".swatch__wrapper.is-selected").forEach(el => {
      el.classList.remove("is-selected");
    });
    colorInput.closest(".swatch__wrapper").classList.add("is-selected");
    window.productVariations.forEach(pv => {
      // if the variation title matches the chosen color, update the price
      if (pv.title === chosenColor) {
        const priceEl = productPicker.querySelector(
          `[data-product-id="${pv.productId}"] .swatch-product-variation__price`
        );
        showPriceDifference(pv);
        priceEl.innerHTML = generatePriceMarkup(pv);
      }
    });
  };
  updateOptions();
  variantPicker.querySelectorAll("input").forEach(input => {
    input.addEventListener("change", updateOptions);
  });
})();
// export { CustomQuote };

document.addEventListener('DOMContentLoaded', function() {
  // var lcp_element = document.getElementById('lcp-presentation');
  // lcp_element.parentNode.removeChild(lcp_element);

  document.addEventListener('dialog:after-show', function() {
    console.log("Dialog-event-------------");
    document.getElementById('shopify-chat').style.visibility = "hidden";
  });
  document.addEventListener('dialog:after-hide', function() {
    console.log("Dialog-event2-------------");
    document.getElementById('shopify-chat').style.visibility = "visible";
  });
});